import { useWebsitesFavicons } from "app/services/sitesService/hooks/useWebsitesFavicons";

import { useUserdataBenchmarkQuery } from "../../../queries/useUserdataBenchmarkQuery";

export const useBenchmarkData = () => {
    const { data: benchmarkData } = useUserdataBenchmarkQuery();
    const domains = benchmarkData?.domains || [];

    const { data: icons, isLoading } = useWebsitesFavicons(domains, undefined, {
        enabled: !!domains.length,
    });

    return {
        icons,
        isLoading,
        primaryDomain: benchmarkData?.primaryDomains[0],
    };
};
